export default "__VITE_ASSET__3c97f992__"